import type { ReactNode } from "react";
import { Button } from "@swot/base-components";

export type SwotExportButtonProps = {
  readonly children?: ReactNode | undefined;
  readonly disabled?: boolean | undefined;
  readonly pending?: boolean | undefined;
  readonly onClick?: (() => void) | undefined;
};

export function SwotExportButton(props: SwotExportButtonProps) {
  return <Button className="swot-export-button" variant="secondary" disabled={props.disabled || props.pending} loading={Boolean(props.pending)} onClick={props.onClick}>{props.pending ? "Exporting" : props.children ?? "Export"}</Button>;
}
